import React from 'react'
import { createRoot } from 'react-dom/client'
import Notification from '../components/notification'
import { ApolloProvider, useQuery } from '@apollo/client'
import fetchNotifications from '../queries/notifications'
import client from '../client'
import PubSub from 'pubsub-js'

// Convert NotificationList to a functional component using useQuery hook
function NotificationList() {
  const [display, setDisplay] = React.useState(false)
  const { loading, error, data } = useQuery(fetchNotifications, {
    pollInterval: 30000,
  })
  const toggleDisplay = () => {
    setDisplay(!display)
  }

  React.useEffect(() => {
    if (data && data.notifications) {
      const re = /^Import completed/
      data.notifications.some((notification) => {
        if (re.exec(notification.message) && !notification.read) {
          PubSub.publish('refresh_users', true)
        }
        return false
      })
    }
  }, [data])

  if (loading) return <div>Loading...</div>
  if (error) return <div>Error :(</div>

  const anyUnread =
    data.notifications && data.notifications.filter((n) => !n.read).length > 0
  const badgeClasses = anyUnread ? 'badge active' : 'badge'
  const listClasses = display ? 'notification-list active' : 'notification-list'

  return (
    <div>
      <a className="notifications-trigger">
        <div className="notification-icon" onClick={toggleDisplay}>
          <i className="material-icons">notifications</i>
          <div className={badgeClasses} />
        </div>
      </a>
      <div
        className={display ? 'overlay no-shadow' : ''}
        onClick={toggleDisplay}
      />
      <div className={listClasses} onClick={toggleDisplay}>
        <h2>Notifications</h2>
        {data.notifications.map((n) => (
          <Notification key={n.id} data={n} active={display} />
        ))}
      </div>
    </div>
  )
}

// Render the NotificationList component
const notificationsList = document.getElementById('notifications-list')
if (notificationsList) {
  const root = createRoot(notificationsList)
  root.render(
    <ApolloProvider client={client}>
      <NotificationList />
    </ApolloProvider>
  )
}
